import { Heart, Home, Play } from "lucide-react";
import { useEffect, useState } from "react";

import { api } from "../api/client";
import type { FamilyMessage } from "../api/types";
import { CommandButton } from "../components/CommandButton";
import { PageShell } from "../components/PageShell";
import {
  DEFAULT_ERROR_RECOVERY_ACTION,
  StatusBlock,
} from "../components/StatusBlock";
import { useAudioCoordinator } from "../stores/audioCoordinator";
import { useNavigationStore } from "../stores/navigationStore";
import styles from "../styles/App.module.css";

export function MessagesPage() {
  const play = useAudioCoordinator((state) => state.play);
  const go = useNavigationStore((state) => state.go);
  const home = useNavigationStore((state) => state.home);
  const [messages, setMessages] = useState<FamilyMessage[]>([]);
  const [messagesLoaded, setMessagesLoaded] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    api
      .messages()
      .then((result) => {
        setMessages(result.items);
        setMessagesLoaded(true);
      })
      .catch((loadError) => {
        setError(
          loadError instanceof Error ? loadError.message : "读取留言失败。",
        );
        setMessagesLoaded(true);
      });
  }, []);

  return (
    <PageShell title="听家人留言" where="家人留言页">
      {error ? (
        <StatusBlock
          tone="error"
          message={error}
          recoveryAction={DEFAULT_ERROR_RECOVERY_ACTION}
        />
      ) : null}
      {!error && !messagesLoaded ? (
        <StatusBlock message="正在读取家人留言。" />
      ) : null}
      {!error && messagesLoaded && messages.length === 0 ? (
        <StatusBlock message="暂时没有家人留言。请家人稍后添加留言。" />
      ) : null}
      <div className={styles.commandList}>
        <CommandButton
          icon={Heart}
          title="我收藏的留言"
          hint="收藏入口在本页第一项"
          onClick={() => go({ name: "favorites" })}
        />
        {messages.map((message, index) => (
          <CommandButton
            key={message.id}
            icon={Play}
            title={message.title}
            hint={`第 ${index + 1} 项，共 ${messages.length} 项，${message.sender_name} 留言`}
            onClick={() => {
              void play({
                title: message.title,
                contentType: "family_message",
                contentId: message.id,
                grant: () => api.messageGrant(message.id),
              });
            }}
          />
        ))}
        <CommandButton
          icon={Home}
          title="留言列表末尾，返回主菜单"
          hint="这是最后一个留言操作，双击返回主菜单"
          onClick={home}
        />
      </div>
    </PageShell>
  );
}
